/**
 * Pushing a master config onto its containers (21/10/2026): which of a
 * container's own sections a push takes back. Every own section goes back
 * to the master's values — Auto-send too (its own layer goes) — except a
 * route test's gateway strategy and pool: they are what it tests.
 * For Media Devoted | Created By Ciro Autiero
 */
import {
  DROP_GEN_SECTIONS,
  type DropGenOwnSections,
  type DropGenSection,
} from "./master.types";

/** A route test's own gateways stay its own — a push never takes them. */
export const ROUTE_TEST_KEEPS: readonly DropGenSection[] = [
  "gatewayStrategy",
  "gatewayPool",
];

export interface PushTarget {
  kind: string;
  ownSections?: DropGenOwnSections | null;
}

/** The sections of `wanted` (every section when absent) this container owns and a push takes back. */
export function pushableSections(
  target: PushTarget,
  wanted?: readonly DropGenSection[],
): DropGenSection[] {
  return DROP_GEN_SECTIONS.filter(
    (s) =>
      target.ownSections?.[s] === true &&
      (!wanted || wanted.includes(s)) &&
      !(target.kind === "ROUTE_TEST" && ROUTE_TEST_KEEPS.includes(s)),
  );
}

/** The container's own sections once `pushed` follow the master again. */
export function withoutSections(
  own: DropGenOwnSections,
  pushed: readonly DropGenSection[],
): DropGenOwnSections {
  const next: DropGenOwnSections = { ...own };
  for (const s of pushed) delete next[s];
  return next;
}

/** POST /drop-generator/masters/:id/push — no sections = every one. */
export interface DropGenMasterPushRequest {
  sections?: DropGenSection[];
}

/** What the push took back, container by container (none = nothing was own). */
export interface DropGenMasterPushResult {
  containers: Array<{ id: string; name: string; sections: DropGenSection[] }>;
}
